'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { GetUserSchema } from '@repo/schema/user';
import { TEST_IDS } from '@repo/sdk/constants';
import { useFormContext, useWatch } from '@repo/sdk/form';
import { useQuery } from '@repo/tanstack/query';
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components';
import { ChevronsUpDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { useState } from 'react';
import { UserCommand } from './user-command';
interface Props {
  className?: string;
  disabled?: boolean;
  onChange: (value: number) => void;
  value?: null | number;
}
const getUserTitle = (user: {
  last_name?: null | string;
  name: string;
}): string => {
  return [user.name, user.last_name].filter(Boolean).join(' ');
};
const getSelectedUser = (user: unknown) => {
  const directUser = GetUserSchema.safeParse(user);
  if (directUser.success) {
    return directUser.data;
  }
  if (user && typeof user === 'object' && 'data' in user) {
    const wrappedUser = GetUserSchema.safeParse(user.data);
    if (wrappedUser.success) {
      return wrappedUser.data;
    }
  }
  return null;
};
export const UserInput = t0 => {
  const $ = _c(34);
  const {
    className,
    disabled: t1,
    onChange,
    value
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const {
    control
  } = useFormContext();
  let t2;
  if ($[0] !== control) {
    t2 = {
      control,
      name: "company_id"
    };
    $[0] = control;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const companyId = useWatch(t2);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const api = useApi();
  let t3;
  if ($[2] !== api.users.getSimple || $[3] !== value) {
    t3 = api.users.getSimple.queryOptions({
      path: {
        id: value ?? 0
      }
    }, {
      enabled: !!value
    });
    $[2] = api.users.getSimple;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: user
  } = useQuery(t3);
  let handleOnChange;
  let t4;
  if ($[5] !== onChange || $[6] !== selectedUser || $[7] !== user || $[8] !== value) {
    const selectedUserData = getSelectedUser(user);
    let t5;
    if ($[11] !== onChange) {
      t5 = selectedUser_0 => {
        onChange(selectedUser_0.id);
        setSelectedUser(selectedUser_0);
        setOpen(false);
      };
      $[11] = onChange;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    handleOnChange = t5;
    t4 = value && selectedUser && selectedUser.id === value ? selectedUser.title : value && selectedUserData ? getUserTitle(selectedUserData) : "Select user";
    $[5] = onChange;
    $[6] = selectedUser;
    $[7] = user;
    $[8] = value;
    $[9] = handleOnChange;
    $[10] = t4;
  } else {
    handleOnChange = $[9];
    t4 = $[10];
  }
  const displayTitle = t4;
  const t5 = disabled ? undefined : setOpen;
  const t6 = disabled ? false : open;
  const t7 = disabled && "cursor-not-allowed opacity-50";
  let t8;
  if ($[13] !== className || $[14] !== t7) {
    t8 = cn("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground hover:bg-neutral-100 dark:hover:bg-neutral-900", t7, className);
    $[13] = className;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== displayTitle) {
    t9 = <span>{displayTitle}</span>;
    $[16] = displayTitle;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronsUpDown className="size-4" data-sentry-element="ChevronsUpDown" data-sentry-source-file="user-input.tsx" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t8 || $[20] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== disabled || $[23] !== t11) {
    t12 = <PopoverTrigger asChild={true} data-testid={TEST_IDS.user.inputTrigger} disabled={disabled} data-sentry-element="PopoverTrigger" data-sentry-source-file="user-input.tsx">{t11}</PopoverTrigger>;
    $[22] = disabled;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== companyId || $[26] !== disabled || $[27] !== handleOnChange) {
    t13 = <PopoverContent align="start" className="w-100 p-0" data-sentry-element="PopoverContent" data-sentry-source-file="user-input.tsx"><UserCommand companyId={companyId} disabled={disabled} onSelect={handleOnChange} data-sentry-element="UserCommand" data-sentry-source-file="user-input.tsx" /></PopoverContent>;
    $[25] = companyId;
    $[26] = disabled;
    $[27] = handleOnChange;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t5 || $[32] !== t6) {
    t14 = <Popover onOpenChange={t5} open={t6} data-sentry-element="Popover" data-sentry-component="UserInput" data-sentry-source-file="user-input.tsx">{t12}{t13}</Popover>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t5;
    $[32] = t6;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};